import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';

/**
 * Component tha permit to seize a reason for a generic action
 */
@Component({
  selector: 'app-ground',
  templateUrl: './ground.component.html',
  styleUrls: ['./ground.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GroundComponent {

  /**
   * Input visibility of the component
   */
  @Input('display') public display: boolean;

  /**
   * Output of the component
   */
  @Output('displayChange') public displayChange: EventEmitter<boolean>;

  /**
   * Output for the reason seized by user
   */
  @Output('reason') public reason: EventEmitter<string>;

  /**
   * Reason seized by user
   */
  public justification: string;

  /**
   * Default constructor, instantiate variables
   */
  constructor() {
    this.displayChange = new EventEmitter<boolean>();
    this.reason = new EventEmitter<string>();
  }

  /**
   * Emit acceptation for the generic action and his justification
   */
  public emitAcceptation(): void {
    this.reason.emit(this.justification);
    this.displayChange.emit(false);
    this.resetComponent();
  }

  /**
   * Reset component to original state
   */
  public resetComponent(): void {
    this.justification = null;
  }

}
